export enum DrawerVariant {
  Primary = 0,
  Secondary = 1,
  Combined = 2,
}

export const ANIMATION_DURATION = 200;

export enum DrawerParams {
  DRAWER_SEARCH_PARAM = "drawer",
  DRAWER_DOC_ID = "DocTypeId",
  DOC = "doc",
}
